import React, { Component } from 'react'
import { Grid, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export default class Walletsuccess extends Component {
  state = {
    intervalId: 5,
    currentCount: 5,
  }

  constructor(props) {
    super(props);

    this.timer = this.timer.bind(this);
  }

  render() {
    return (
      <div>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Grid stackable>
                <Grid.Row>
                  <div
                    style={{ margin: '0 auto', display: 'block' }}
                  ><br /><br /><Icon name='check' size="massive" color="green" /></div>
                </Grid.Row>
                <Grid.Row>
                  <div
                    style={{ margin: '0 auto' }}
                  >
                    <p
                      style={{
                        fontSize: '50px',
                        textAlign: "center",
                        margin: '0',
                        color: '#666',
                        textTransform: 'uppercase'
                      }}
                    >Successful</p>
                    <p
                      style={{textAlign: 'center', fontSize: '16px'}}
                    >Your transaction was successful, you will be redirected to accounts page in <strong>{this.state.currentCount}</strong> seconds, if not please click <Link to="/accounts">here</Link>.</p>
                  </div>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }

  timer() {
    this.setState({ currentCount: this.state.currentCount -1 });
 }

  componentDidMount() {
    const { history } = this.props;

    const intervalId = setInterval(this.timer, 1000);
   // store intervalId in the state so it can be accessed later:
    this.setState({intervalId: intervalId});

    setTimeout(() => {
      history.push('/accounts');
    }, 5000);
  }

  componentWillUnmount() {
    // use intervalId from the state to clear the interval
    clearInterval(this.state.intervalId);
 }
}
